import { render, staticRenderFns } from "./Panel2.vue?vue&type=template&id=84ee0fd2&scoped=true&"
import script from "./Panel2.vue?vue&type=script&lang=js&"
export * from "./Panel2.vue?vue&type=script&lang=js&"
import style0 from "./Panel2.vue?vue&type=style&index=0&id=84ee0fd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ee0fd2",
  null
  
)

export default component.exports